import { Stack, Box, SystemProps } from "@storyofams/react-ui";
import { usePostHog } from "posthog-js/react";
import styled from "styled-components";

const Wrapper = styled(Stack)`
  &:after {
    content: "";
    position: absolute;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 1px;
  }
`;

const Tab = styled(Box).attrs({ as: "button" })`
  color: #767473;
  font-weight: 500;
  position: relative;
  &:after {
    content: "";
    width: 100%;
    height: 2px;
    position: absolute;
    z-index: 99999;
    bottom: 0;
    left: 0;
    transition: background-size 0.25s ease-in-out;
    background: linear-gradient(
      ${(p) => p.theme.colors.grey800},
      ${(p) => p.theme.colors.grey800}
    );
    background-size: 0% 2px;
    background-position: center center;
    background-repeat: no-repeat;
  }

  &.active {
    color: ${(p) => p.theme.colors.grey800};

    &:after {
      background-size: 100% 2px;
    }
  }
`;

interface TabsProps {
  tabs: {
    label: string;
    tab: string;
  }[];
  activeTab: string;
  onClick(idx): void;
  isPP?: boolean;
  isRecipe?: boolean;
}

export const Tabs = ({
  activeTab,
  onClick,
  tabs,
  isPP,
  isRecipe = false,
  ...props
}: TabsProps & Omit<SystemProps, "flexDirection">) => {
  const posthog = usePostHog();
  return (
    <Wrapper
      justifyContent={isPP ? "start" : "space-between"}
      space={isRecipe ? "auto" : 4}
      overflowX="auto"
      pb={2}
      width={"100%"}
      {...props}
    >
      {tabs?.map(({ tab, label }) => (
        <Tab
          key={tab}
          py={"13px"}
          px={isRecipe && "15px"}
          flexShrink={0}
          className={activeTab === tab ? "active" : ""}
          color={activeTab === tab ? "black" : "grey700"}
          onClick={() => {
            onClick(tab);
            // posthog.capture("Clicked Product Page Menu");
          }}
        >
          {label}
        </Tab>
      ))}
    </Wrapper>
  );
};
